import { axiosApiClient } from "..";
import { handleError } from "../../utils/errors";

const BASE_URL = "/news";

class NewsService {
  // Postojeće funkcije...
  getNews = async ({ page, search, includeInactive = false }) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/`, {
        params: { page, search, includeInactive },
      });
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching news.");
    }
  };

  getFeaturedNews = async () => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/featured`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching featured news.");
    }
  };

  getNewsById = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching news by id.");
    }
  };

  createNews = async (requestData) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/`, requestData);
      if (response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating news.");
    }
  };

  deleteNews = async (id) => {
    try {
      const response = await axiosApiClient.delete(`${BASE_URL}/${id}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while deleting news.");
    }
  };

  toggleNewsStatus = async (id) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}/toggle-status`
      );
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while toggling news status.");
    }
  };

  editNews = async ({ id, requestData }) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}`,
        requestData
      );
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while editing news.");
    }
  };

  // NOVE FUNKCIJE ZA DETAILS
  getNewsDetails = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}/details`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while fetching news details.");
    }
  };

  updateNewsDetails = async ({ id, data }) => {
    try {
      const response = await axiosApiClient.put(
        `${BASE_URL}/${id}/details`,
        data
      );
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while updating news details.");
    }
  };

  createNewsDetails = async (data) => {
    try {
      const response = await axiosApiClient.post(`${BASE_URL}/details`, data);
      if (response.status !== 201) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error occurred while creating news details.");
    }
  };

  // Za javni prikaz sa HTML content-om
  getNewsPublicDetails = async (id) => {
    try {
      const response = await axiosApiClient.get(`${BASE_URL}/${id}/details`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(
        err,
        "Error occurred while fetching public news details."
      );
    }
  };
}

const newsService = new NewsService();
export default newsService;
